import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './RestauranteManglePage.css';


import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';


import restauranteHero from '../../../../assets/restaurante-hero.png';
import mangleLogoWhite from '../../../../assets/mangle-restaurante-logo.png';

// 2. ---  IMÁGENES PARA EL PRIMER CARRUSEL ---
import carruselImg1 from '../../../../assets/restaurante-carrusel-1.png'; 
import carruselImg2 from '../../../../assets/restaurante-carrusel-2.png';
import carruselImg3 from '../../../../assets/restaurante-carrusel-3.png';
import carruselImg4 from '../../../../assets/restaurante-carrusel-4.png';
import carruselImg5 from '../../../../assets/restaurante-carrusel-5.png';
import carruselImg6 from '../../../../assets/restaurante-carrusel-6.png';

// --- Imágenes para la sección de features ---
import mangleSunset from '../../../../assets/mangle-sunset.jpg';
import mangleLogoBlack from '../../../../assets/logo-mangle-beach-bar.png';

// ---  IMÁGENES PARA EL SEGUNDO CARRUSEL  ---
import mangleSwing1 from '../../../../assets/mangle-swing-1.png';
import mangleSwing2 from '../../../../assets/mangle-swing-2.png';
import mangleSwing3 from '../../../../assets/mangle-swing-3.png';
import mangleSwing4 from '../../../../assets/mangle-swing-4.png';

const carouselImages = [
  carruselImg1,
  carruselImg2,
  carruselImg3,
  carruselImg4,
  carruselImg5,
  carruselImg6,
];

const RestauranteManglePage: React.FC = () => {
  
  const { i18n } = useTranslation();
  const currentLang = i18n.language.split('-')[0]; 

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="restaurant-page-container">
      <header
        className="restaurant-hero"
        style={{ backgroundImage: `url(${restauranteHero})` }}
      >
        <div className="restaurant-hero-overlay"></div>
        <h1 className="restaurant-hero-title" data-aos="fade-up">
           <Trans i18nKey="restaurantMangle:heroTitle" />
        </h1>
      </header>

      <section className="restaurant-intro">
        <div className="intro-content" data-aos="fade-right">
          <img src={mangleLogoWhite} alt="Mangle Restaurante" className="mangle-logo" />
          <h2 className="intro-title">
             <Trans i18nKey="restaurantMangle:intro.title" />
          </h2>
          <p>
            <Trans 
               i18nKey="restaurantMangle:intro.description1"
               components={{ strong: <strong /> }}
            />
          </p>
          <p>
            <Trans 
               i18nKey="restaurantMangle:intro.description2"
               components={{ strong: <strong /> }}
            />
          </p>
        </div>

        {/* 4. ---CARRUSEL 1 'Swiper' --- */}
        <div className="restaurant-carousel-wrapper" data-aos="fade-left">
          <Swiper
            modules={[Navigation]} 
            navigation 
            slidesPerView={2} 
            spaceBetween={20}
            loop={true} 
            className="restaurant-swiper"
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 10 },
              769: { slidesPerView: 2, spaceBetween: 20 },
            }}
          >
            {carouselImages.map((imgSrc, index) => (
              <SwiperSlide key={index}>
                <img
                  src={imgSrc}
                  alt={`Interior del restaurante ${index + 1}`}
                  className="restaurant-carousel-image"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      <section className="restaurant-details">
        <div className="details-content" data-aos="fade-up">
          <p>
             <Trans 
               i18nKey="restaurantMangle:details.mainText"
               components={{ strong: <strong /> }}
            />
          </p>
          <div className="details-info">
            <p>
               
               <Trans 
                 i18nKey="restaurantMangle:details.info"
                 components={{ strong: <strong />, br: <br /> }}
               />
            </p>
          </div>

          <Link
            to={`/${currentLang}/hotel/menu-mangle`}
            className="menu-button"
            data-aos="zoom-in"
          >
            <Trans i18nKey="restaurantMangle:details.menuButton" />
          </Link>
        </div>
        <div className="linea-global"></div>

      </section>

      <section className="restaurant-features-section">
        <div className="features-grid">
          
         
          <div className="grid-item-1" data-aos="fade-right">
            <img src={mangleSunset} alt="Atardecer en Mangle" className="feature-image" />
          </div>

          
          <div className="grid-item-2" data-aos="fade-left">
            <img src={mangleLogoBlack} alt="Logo Mangle" className="mangle-logo-small" />
            <div className="feature-text-block">
              <p>
                 <Trans i18nKey="restaurantMangle:features.block1" />
              </p>
            </div>
          </div>

          
          <div className="grid-item-3" data-aos="fade-right">
            <div className="feature-text-block">
              <p>
                <Trans i18nKey="restaurantMangle:features.block2" />
              </p>
              <p>
                <Trans i18nKey="restaurantMangle:features.block3" />
              </p>
            </div>
          </div>

          <div 
            className="grid-item-4" 
            data-aos="fade-left"
            style={{ 
              height: '400px',  
              position: 'relative' 
            }}
          >
            
            <Swiper
              modules={[Navigation]}
              navigation={{
                nextEl: '.grid-item-4 .swiper-arrow-next',
                prevEl: '.grid-item-4 .swiper-arrow-prev',
              }}
              slidesPerView={1}
              spaceBetween={10}
              loop={true}
              className="restaurant-swiper" 
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }}
            >
              <SwiperSlide>
                <img src={mangleSwing1} alt="Columpio en Mangle 1" className="carousel-image" />
              </SwiperSlide>
              <SwiperSlide>
                <img src={mangleSwing2} alt="Columpio en Mangle 2" className="carousel-image" />
              </SwiperSlide>
              <SwiperSlide>
                <img src={mangleSwing3} alt="Columpio en Mangle 3" className="carousel-image" />
              </SwiperSlide>
              <SwiperSlide>
                <img src={mangleSwing4} alt="Columpio en Mangle 4" className="carousel-image" />
              </SwiperSlide>
            </Swiper>
            
         
            <div className="swiper-arrow swiper-arrow-prev">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
            </div>
            <div className="swiper-arrow swiper-arrow-next">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default RestauranteManglePage;